import React from 'react';
import { Badge, ConditionalWrapper, Box } from '@landr/maestro';
import { t } from '@lingui/macro';

const TakenDownBadge: React.FC<{
    isAbsolute?: boolean;
}> = ({ isAbsolute = false }) => (
    <ConditionalWrapper
        condition={isAbsolute}
        wrapper={(children: React.ReactNode): React.ReactNode => (
            <Box
                position="absolute"
                top="0"
                left="0"
                marginTop="xs"
                marginLeft="xs"
                pointerEvents="none"
            >
                {children}
            </Box>
        )}
    >
        <Badge
            variant="warning"
            kind="subtle"
            label={t`unavailable`}
            size="sm"
            isRounded={true}
        />
    </ConditionalWrapper>
);

export default TakenDownBadge;
